import { useState, useEffect } from 'react';
import ContactModal from '../components/ContactModal';

const ContactPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
  });
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          element.classList.add('opacity-100', 'translate-y-0', 'scale-100');
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    // // Aquí simularías el envío del formulario a un backend
    // console.log('Formulario enviado:', formData);

    // // Simulación de éxito/error
    // if (formData.name && formData.email && formData.message) {
    //   setSubmitStatus('success');
    //   setFormData({ name: '', email: '', phone: '', company: '', message: '' }); // Limpiar formulario
    // } else {
    //   setSubmitStatus('error');
    // }

    // // Ocultar el mensaje de estado después de unos segundos
    // setTimeout(() => {
    //   setSubmitStatus(null);
    // }, 5000);

    e.preventDefault();

      const formData = new FormData(e.target);

      const res = await fetch("https://rmcomponentes.com/send.php", {
        method: "POST",
        body: formData,
      });

      const text = await res.text();
      alert(text);
  };

  return (
    <>
    <div className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-gray-900 mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
          <span className="text-red-600">Contáctanos</span>
        </h1>

        <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-100">
          Estamos listos para atender tus dudas y ofrecerte la mejor solución para tus necesidades de automatización industrial. Tu éxito es nuestra prioridad.
        </p>

        <div className="flex justify-center mt-8">

          <button 
            onClick={() => setIsModalOpen(true)} 
            className="bg-white text-red-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
          >
            Cotizar Ahora
          </button>
        </div> 

        <div className="md:flex gap-10">
          {/* Información de contacto */}
          <div className="md:w-1/3 mb-12 md:mb-0 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-200">
            <div className="bg-white p-10 rounded-xl shadow-xl h-full">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Información de Contacto</h2>

              {/* Ubicación */}
              <div className="mb-8 flex items-start">
                <svg className="h-6 w-6 text-red-600 mr-3 mt-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
                </svg>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">Oficina Central</h3>
                  <p className="text-gray-700 leading-relaxed">Carretera Sanchez Vieja, Bajos de Haina. San Cristobal</p>
                  <p className="text-gray-700 leading-relaxed">Santo Domingo, 91000</p>
                </div>
              </div>

              {/* Horario */}
              <div className="mb-8 flex items-start">
                <svg className="h-6 w-6 text-red-600 mr-3 mt-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 8v5l4 2 1-1.73-3.5-1.77V8z" />
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                </svg>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">Horario</h3>
                  <p className="text-gray-700 leading-relaxed">Lunes a Viernes: 8:00AM - 5:00PM</p>
                  <p className="text-gray-700 leading-relaxed">Sábados: 8:00AM - 12:00PM</p>
                </div>
              </div>

              {/* Teléfono */}
              <div className="mb-8 flex items-start">
                <svg className="h-6 w-6 text-red-600 mr-3 mt-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.21.48 2.53.74 3.88.74a1 1 0 011 1v3.5a1 1 0 01-1 1C10.07 21 3 13.93 3 5.5a1 1 0 011-1H7.5a1 1 0 011 1c0 1.35.26 2.67.74 3.88a1 1 0 01-.21 1.11l-2.2 2.2z" />
                </svg>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">Teléfono</h3>
                  <p className="text-gray-700 leading-relaxed">(809) 957 1865</p>
                </div>
              </div>

              {/* Email */}
              <div className="mb-8 flex items-start">
                <svg className="h-6 w-6 text-red-600 mr-3 mt-1" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 2v.01L12 13 4 6.01V6h16zM4 18V8l8 5 8-5v10H4z" />
                </svg>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">Email</h3>
                  <p className="text-gray-700 leading-relaxed">ventas@rmcomponentes.com</p>
                  <p className="text-gray-700 leading-relaxed">ventas1@rmcomponentes.com</p>
                </div>
              </div>

              {/* Redes Sociales */}
              <div className="flex space-x-6">
                <a href="#" className="text-gray-600 hover:text-red-600 transform hover:scale-125 transition-transform duration-300">
                  <span className="sr-only">Facebook</span>
                  <svg className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.364 0 2.07.103 2.07.103v2.383h-1.292c-1.26 0-1.653.785-1.653 1.59V12h2.679l-.428 2.893h-2.251v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                  </svg>
                </a>
                <a href="https://www.instagram.com/rmcomponentesind/" className="text-gray-600 hover:text-red-600 transform hover:scale-125 transition-transform duration-300">
                  <span className="sr-only">Instagram</span>
                  <svg className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                    <path fillRule="evenodd" d="M12 0C8.74 0 8.333.014 7.053.072 5.775.132 4.92.333 4.145.645 3.369.957 2.671 1.45 1.979 2.142.59 3.53 0 5.12 0 7.055v9.89C0 18.88 0 20.47 1.39 21.858 2.78 23.248 4.37 23.248 6.3 23.248h9.89c1.935 0 3.525 0 4.915-1.39C23.248 20.47 23.248 18.88 23.248 16.955V7.053C23.248 5.12 23.248 3.53 21.858 2.142 20.47 0.752 18.88 0.752 16.955 0.752H7.053zM12 5.77c3.43 0 6.23 2.8 6.23 6.23s-2.8 6.23-6.23 6.23-6.23-2.8-6.23-6.23 2.8-6.23 6.23-6.23zm0 2.105c-2.28 0-4.125 1.845-4.125 4.125S9.72 16.23 12 16.23s4.125-1.845 4.125-4.125S14.28 7.875 12 7.875zM18.455 4.41c-.74 0-1.34-.6-1.34-1.34s.6-1.34 1.34-1.34 1.34.6 1.34 1.34-.6 1.34-1.34 1.34z" clipRule="evenodd" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          
          {/* Formulario */}
          <div className="md:w-2/3 bg-white p-10 rounded-xl shadow-xl animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-300">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Envía un mensaje</h2>
            <form action="https://rmcomponentes.com/send.php" method='post' >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <label htmlFor="name" className="block text-lg font-medium text-gray-700 mb-2">Nombre</label>
                  <input type="text" id="name" name='nombre' value={formData.name} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500 transition-all duration-300" required />
                </div>
                <div>
                  <label htmlFor="email" className="block text-lg font-medium text-gray-700 mb-2">Email</label>
                  <input type="email" id="email" name='email' value={formData.email} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500 transition-all duration-300" required />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-lg font-medium text-gray-700 mb-2">Teléfono</label>
                  <input type="tel" id="phone" name='telefono' value={formData.phone} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500 transition-all duration-300" />
                </div>
                <div>
                  <label htmlFor="company" className="block text-lg font-medium text-gray-700 mb-2">Empresa</label>
                  <input type="text" id="company" name='empresa' value={formData.company} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500 transition-all duration-300" />
                </div>
                <div className="md:col-span-2">
                  <label htmlFor="message" className="block text-lg font-medium text-gray-700 mb-2">Mensaje</label>
                  <textarea id="message" name='mensaje' rows="6" value={formData.message} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500 transition-all duration-300 resize-none" required></textarea>
                </div>
              </div>
              <button type="submit" className="mt-10 bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-10 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg">
                Enviar mensaje
              </button>
              {submitStatus === 'success' && (
                <p className="mt-4 text-green-600 font-semibold text-center">¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.</p>
              )}
              {submitStatus === 'error' && (
                <p className="mt-4 text-red-600 font-semibold text-center">Hubo un error al enviar el mensaje. Por favor, completa todos los campos requeridos.</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
    {/* Modal de Contacto */}
    <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
    
  );
};
export default ContactPage;

// DONE